import anthropicIcon from 'assets/images/ai-providers/anthropic.svg';
import azureIcon from 'assets/images/ai-providers/azure-color.svg';
import customIcon from 'assets/images/ai-providers/custom.svg';
import deepseekIcon from 'assets/images/ai-providers/deepseek-color.svg';
import geminiIcon from 'assets/images/ai-providers/gemini-color.svg';
import mistralIcon from 'assets/images/ai-providers/mistral-color.svg';
import openaiIcon from 'assets/images/ai-providers/openai.svg';

export const ProviderNameMap: Record<string, string> = {
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  google: 'Gemini',
  gemini: 'Gemini',
  mistral: 'Mistral',
  deepseek: 'DeepSeek',
  azure: 'Azure',
  openrouter: 'OpenRouter',
  custom: 'Custom Model',
};

export const ProviderIconMap: Record<string, string | undefined> = {
  openai: openaiIcon,
  anthropic: anthropicIcon,
  google: geminiIcon,
  gemini: geminiIcon,
  mistral: mistralIcon,
  deepseek: deepseekIcon,
  azure: azureIcon,
  custom: customIcon,
};

const MonochromeProviderIcons = new Set(['openai', 'anthropic', 'custom']);

export const getProviderDisplayName = (provider?: string) => {
  if (!provider) return 'Provider';
  return ProviderNameMap[provider.toLowerCase()] ?? provider;
};

export const getProviderIcon = (provider?: string) => {
  if (!provider) return undefined;
  return ProviderIconMap[provider.toLowerCase()];
};

export const getProviderIconClassName = (provider?: string, theme?: string) => {
  if (!provider) return 'h-6 w-6 object-contain';

  const providerKey = provider.toLowerCase();
  const isMonochrome = MonochromeProviderIcons.has(providerKey);

  return [
    'h-6 w-6 object-contain',
    theme === 'dark' && isMonochrome ? 'brightness-0 invert' : '',
  ]
    .filter(Boolean)
    .join(' ');
};
